module.exports = __webpack_public_path__ + "static/media/20.b5127f40.jpg";